/* eslint-disable no-param-reassign */
import produce from 'immer';
var userLoaded = produce(function (draft, action) {
  var user = action.payload.user;
  draft.current = user;
  draft.error = null;
});
export default userLoaded;